import { CloudActions, AuthServiceUrls } from '@portal/portal-core';
import { call } from 'redux-saga/effects';
import { sendAction } from '../utils';

interface AuthcodeSagaConfig {
  getAuthToken: () => string | null | undefined;
}

interface AuthcodeRedirectPayload {
  baseUrl: string;
  userId: string;
  primaryEmail: string;
  product: string;
  productAccessId: string;
  costCenterId: string;
}

interface AuthcodeRedirectAction {
  type: string;
  payload: AuthcodeRedirectPayload;
}

// Shape of the resolved result returned by the untyped `sendAction` util
interface SendActionResult {
  succeeded?: boolean;
  data?: string;
  error?: unknown;
}

export function* authcodeRedirectSaga(
  config: AuthcodeSagaConfig,
  action: AuthcodeRedirectAction,
): Generator<unknown, void, unknown> {
  const url = AuthServiceUrls.generateUserAuthTokenPath();
  const { baseUrl, userId, primaryEmail, product: productName } = action.payload;
  const serverAction = CloudActions.generateUserAuthToken(userId, primaryEmail);

  try {
    const res = (yield call(sendAction, config, serverAction, url)) as SendActionResult;
    const { succeeded, data, error } = res;
    if (!succeeded) {
      console.log('failed', error);
    } else if (data) {
      // TODO investigate if this is the URL to FlowJo Hub and if product needs to be productName or not
      const destinationUrl = `${baseUrl}?product=${productName}&code=${data}`;
      const urlWithParams = (['productAccessId', 'costCenterId'] as const).reduce(
        (acc: string, param) =>
          action.payload[param] ? `${acc}&${param}=${action.payload[param]}` : `${acc}`,
        destinationUrl,
      );
      window.open(urlWithParams, '_blank');
    }
  } catch (error) {
    console.log('error', error);
  }
}
